import { ref, onMounted } from 'vue'
import { useNuxtApp } from '#app'

const isLoading = ref(false)
let initialized = false

/**
 * Tracks page loading and optionally triggers loading on first hydration.
 */
export function useLoading() {
  const nuxtApp = useNuxtApp()

  if (!initialized && import.meta.client) {
    // Navigation loading
    nuxtApp.hook('page:loading:start', () => {
      isLoading.value = true
    })

    nuxtApp.hook('page:loading:end', () => {
      isLoading.value = false
    })

    // Initial hydration flicker
    onMounted(() => {
      isLoading.value = true
      setTimeout(() => {
        isLoading.value = false
      }, 400) // adjust duration to match your visual style
    })

    initialized = true
  }

  return { isLoading }
}
